import { combineReducers } from 'redux-immutable'
import { fromJS } from 'immutable';
import { dummyReducerFacory, onGet, onError } from '../helpers';
import requestStatus from '../../constants/requestStatus';
import newslettersReducer from './newsletterReducer';
import newslettersElementsReducer from './elements';
import actionTypes from '../../actions/actionTypes';


const INIT_STATE = fromJS({
    status: requestStatus.INITIALIZED,
    error: null,
    hasChanges: false,
    newsletters: {
        items: {}
    },
    texts: {
        items: {}
    },
    images: {
        items: {}
    }
});



const onLocalDataSuccess = (state, action) => {
    return state 
        .set('status', requestStatus.REQUEST_SUCCESS)
        .set('error', '')
        .set('hasChanges', false)
        .set('newsletters', fromJS(action.payload.newsletters))
        .set('texts', fromJS(action.payload.texts))
        .set('images', fromJS(action.payload.images))
}

const onSendSuccess = (state) => {
    return state 
        .set('status', requestStatus.REQUEST_SUCCESS)
        .set('error', '')
}

const onHasChanges = (state) => {
    if(!state.hasChanges) {
        return state.set('hasChanges', true)
    } else {
        return state
    }
}

const onCancelRequest = (state) => {
    return state
        .set('status', requestStatus.INITIALIZED)
        .set('error', null)
}



const textReducer = newslettersElementsReducer('texts')
const imageReducer = newslettersElementsReducer('images')


const combinedReducer = combineReducers({
    status:                 dummyReducerFacory(INIT_STATE.get('status')),
    error:                  dummyReducerFacory(INIT_STATE.get('error')),
    hasChanges:             dummyReducerFacory(INIT_STATE.get('hasChanges')),
    newsletters: newslettersReducer,
    texts: textReducer,
    images: imageReducer
});



const newsletterLocalDataReducer = (state = INIT_STATE, action) => {
    switch(action.type) {
        case actionTypes.NEWSLETTER_GET_REQUEST:
        case actionTypes.NEWSLETTER_UPDATE_REQUEST:
        case actionTypes.NEWSLETTER_SEND_REQUEST:
            state = onGet(state, action) 
            break

        case actionTypes.NEWSLETTER_GET_SUCCESS:
        case actionTypes.NEWSLETTER_UPDATE_SUCCESS:
            state = onLocalDataSuccess(state, action)
            break 

        case actionTypes.NEWSLETTER_SEND_SUCCESS:
            state = onSendSuccess(state)
            break

        case actionTypes.NEWSLETTER_GET_ERROR:
        case actionTypes.NEWSLETTER_UPDATE_ERROR:
        case actionTypes.NEWSLETTER_FILTER_ERROR:
        case actionTypes.NEWSLETTER_SEND_ERROR:
            state = onError(state, action)
            break

        case actionTypes.NEWSLETTER_CREATE_ITEM:
        case actionTypes.NEWSLETTER_UPDATE_ITEM:
        case actionTypes.NEWSLETTER_DELETE_ITEM:
        case actionTypes.NEWSLETTER_ADD_NEWSLETTER_ITEM:
        case actionTypes.NEWSLETTER_REORDER_NEWSLETTER_ITEM:
        case actionTypes.NEWSLETTER_DELETE_NEWSLETTER_ITEM:
        case actionTypes.NEWSLETTER_UPDATE_NEWSLETTER_CURRENT_WEEK:
            state = onHasChanges(state)
            break

        case actionTypes.NEWSLETTER_CANCEL_REQUEST:
            state = onCancelRequest(state)
    }

    return combinedReducer(state, action)
}

export default newsletterLocalDataReducer;